




























import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const smartMarketing = namespace('smartMarketing')

@Component
export default class CompanySettingsSmartMarketingEventTracking extends Vue {
    @smartMarketing.State readonly eventTrackingEnabled!: boolean
    @smartMarketing.State readonly eventTrackingAccountId!: string|null
    @smartMarketing.State readonly eventTrackingKey!: string|null
    @smartMarketing.Action readonly updateEventTrackingEnabled!: (eventTrackingEnabled: boolean) => Promise<void>
    @smartMarketing.Action readonly updateEventTrackingAccountId!: (eventTrackingAccountId: string) => Promise<void>
    @smartMarketing.Action readonly updateEventTrackingKey!: (eventTrackingKey: string) => Promise<void>
}
